<template>
  <div class="allot-manage-modal border-r-8">
    <div class="p-10-15 flex-side">
      <div>
      </div>
      <el-button
        type="primary"
        @click="addManager"
        v-show="storeDataList.length"
        >新增管家</el-button
      >
    </div>
    <r-table
      :dataSource="keeperList"
      :options="options"
      :showPagination="false"
      @current-change="handlePageChange"
      @row-click="handleRowClick"
    >
      <el-table-column
        prop="realName"
        show-overflow-tooltip
        label="姓名"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="idCardNum"
        show-overflow-tooltip
        label="身份证号"
      ></el-table-column>
      <el-table-column
        prop="phoneNum"
        show-overflow-tooltip
        label="手机号码"
      ></el-table-column>
      <el-table-column prop="operate" show-overflow-tooltip label="操作">
        <template #default="scope">
          <el-button
            class="border-btn primary"
            size="small"
            @click="editManager(scope.row)"
            >编辑</el-button
          >
          <el-button
            class="border-btn warn"
            size="small"
            @click="delManager(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </r-table>
  </div>
  <!-- <div class="align-c m-t-20 p-t-10">
    <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
  </div> -->
  <RModal
    :title="(currentKeeper && '编辑管家') || '新增管家'"
    v-model="addManagerModalShow"
    :closeOnClick="true"
    @change="addManagerModalShow = false"
  >
    <template v-slot:content>
      <add-manager-modal
        v-if="addManagerModalShow"
        :keeper="currentKeeper"
        :storeId="shopId"
        @close="closeModal"
      ></add-manager-modal>
    </template>
  </RModal>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import addManagerModal from './addManagerModal';
import RModal from '@/components/common/RModal';
import { mapActions } from "vuex";
export default {
  components: { RTable, RModal, addManagerModal },
  mixins: [tableMix],
  props: ['shopId'],
  watch: {
    shopId(){
      this.getQuery();
    }
  },
  emits: ['close'],
  data() {
    return {
      storeDataList: [],
      keeperList: [],
      tableColumn: [],
      addManagerModalShow: false,
      currentKeeper: null
    }
  },
  created() {
    this.getStoreList();
    this.initTableOptions();
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取门店列表
    getStoreList() {
      let url = 'SHOP.GET_LIST'
      this.fetchData({
        url,
        method: 'get'
      }).then(res => {
        this.storeDataList = res?.data || [];
        this.getQuery();
      })
    },

    // 获取当前门店管家列表
    getQuery() {
      if (!this.shopId) return;
      this.fetchData({
        url: 'SHOP.KEEPER_LIST',
        method: 'get',
        params: { id: this.shopId }
      }).then(res => {
        this.keeperList = res || [];
      })
    },

    // 初始化table配置
    initTableOptions() {
      this.options.calculateHeight = false;
      this.options.height = "400px";
    },


    // 门店变更
    storeChange() {
      this.getQuery();
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    },

    //新增管家
    addManager() {
      this.currentKeeper = null;
      this.addManagerModalShow = true;
    },

    // 编辑管家
    editManager(id) {
      this.currentKeeper = id;
      this.addManagerModalShow = true;
    },

    // 删除管家 -- step1:解绑
    delManager(keeperId) {
      if (!keeperId) return;
      this.$confirm('确定删除该管家吗？', {
        type: 'warning'
      }).then(() => {
        this.fetchData({
          url: 'SHOP.KEEPER_UNBOUND',
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          params: { id: this.shopId, housekeeper: keeperId },
          flag: true
        }).then(res => {
          console.log(res.code,res.data,res.code === 200)
          if (res.code === 200 && res.data) {
            this.delManagerNext(keeperId);
          } else {
            this.$message.error('解绑失败')
          }
        })
      })
    },

    // 删除管家-- step2:删除
    delManagerNext(id) {
      this.fetchData({
        url: 'USER.KEEPER_DELETE',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params: { id }
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getQuery()
        } else {
          this.$message.error('操作失败')
        }
      }).catch(() => {
        this.$message.error('操作失败')
      })
    },

    // 关闭新增管家弹框
    closeModal($event) {
      this.addManagerModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },
  },

}
</script>

<style lang="less" scoped>
</style>